import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Col, Container, Row} from 'reactstrap';
import {toast} from 'react-toastify';
import {message} from 'antd';

class Footer extends Component {

    constructor(props) {
        super(props)
        this.state = {
            email: '', submitted: false
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    handleInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }


    handleSubmit = async (e) => {
        e.preventDefault();
        const {email} = this.state;

        try {
            const response = await fetch('https://apis.windeal.co.ke/postdata', {
                method: 'POST', headers: {
                    'Content-Type': 'application/json', 'x-api-key': 'qyfCv4sBd0fcquNZijY9nhN7szU4a7KS'
                }, body: JSON.stringify({
                    organisation: 'nafsi',
                    rpcQueue: 'nafsi',
                    menu: 'notification',
                    method: 'saveWebsiteSubmission',
                    type: 'QUOTE',
                    name: email,
                    email,
                    message: 'Want to Know More on our products',
                })
            });

            const data = await response.json();
            const result = JSON.parse(data.result);
            if (result?.v_field39 === '00') {
                toast.success(data?.v_field48 || 'Successfully submitted.');

                this.setState({email: ''});
                setTimeout(() => {
                    this.setState({submitted: false});
                }, 5000);

            } else {
                toast.error(data?.v_field48 || 'Failed to submit your request. Please try again.');
            }
        } catch (error) {
            toast.error('Network error. Please check your connection.');
        }

    }


    render() {
        return (<footer id="Careers" className="py-11 position-relative" style={{backgroundColor: '#0d153b'}}
                        data-bg-img="assets/images/bg/03.png">
            <div className="shape-1" style={{height: '150px', overflow: 'hidden'}}>
                <svg viewBox="0 0 500 150" preserveAspectRatio="none" style={{height: '100%', width: '100%'}}>
                    <path d="M0.00,49.98 C150.00,150.00 271.49,-50.00 500.00,49.98 L500.00,0.00 L0.00,0.00 Z"
                          style={{stroke: 'none', fill: '#fff'}}/>
                </svg>
            </div>
            <Container className=" mt-11">
                <Row>
                    <div className="col-12 col-lg-5 col-xl-4 mr-auto mb-6 mb-lg-0">
                        <div className="subscribe-form bg-warning-soft p-5 rounded">
                            <h5 className="mb-4 text-white">Want to Know More?</h5>
                            <h6 className="text-light">Leave your email</h6>
                            <form id="mc-form" className="group" onSubmit={this.handleSubmit}>
                                <input type="email"
                                       name="email"
                                       value={this.state.email}
                                       onChange={this.handleInputChange}
                                       className="email form-control"
                                       id="mc-email"
                                       placeholder="Email Address"
                                       required style={{height: '60px'}}
                                />
                                <input className="btn btn-outline-light btn-block mt-3 mb-2" type="submit"
                                       name="subscribe" defaultValue="Subscribe"/>
                            </form>
                            <small className="text-light">We will respond within one working day.</small>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6 col-xl-7">
                        <Row>
                            <Col className="col-12 col-sm-6 navbar-dark">
                                <h5 className="mb-4 text-white">What we do</h5>
                                <ul className="navbar-nav list-unstyled mb-0">
                                    <li className="mb-3 nav-item"><Link className="nav-link" to="/#home">Face
                                        Matching & Biometric Verification</Link>
                                    </li>
                                    <li className="mb-3 nav-item"><Link className="nav-link" to="/#home">Liveness
                                        Detection & Anti-Spoofing</Link>
                                    </li>
                                    <li className="mb-3 nav-item"><Link className="nav-link" to="/#home">Document
                                        Authentication & KYC</Link>
                                    </li>
                                    <li className="mb-3 nav-item"><Link className="nav-link" to="/#home">Fraud
                                        Prevention & Risk Assessment</Link>
                                    </li>
                                </ul>
                            </Col>
                            <Col className="col-12 col-sm-3 mt-6 mt-sm-0 navbar-dark">
                                <h5 className="mb-4 text-white">Legal</h5>
                                <ul className="navbar-nav list-unstyled mb-0">
                                    <li className="mb-3 nav-item"><Link className="nav-link" to="/term-condition">Term
                                        Of Service</Link>
                                    </li>
                                    <li className="mb-3 nav-item"><Link className="nav-link" to="/privacy-policy">Privacy
                                        Policy</Link>
                                    </li>
                                </ul>
                            </Col>
                        </Row>
                        <Row className="mt-5">
                            <Col className="col-12 col-sm-6">
                                <Link className="footer-logo text-white h2 mb-0 d-flex align-items-center" to="/">
                                    <img src={require('../../assets/images/logo-144-144.png')} alt="nafsi.ai"
                                         style={{
                                             height: '40px',
                                             width: 'auto',
                                             filter: 'brightness(0) invert(1)',
                                             marginRight: '10px'
                                         }}/>
                                    nafsi<span className="font-weight-bold">.ai</span>
                                </Link>
                            </Col>
                            <Col className="col-12 col-sm-6 mt-6 mt-sm-0">
                                <ul className="list-inline mb-0">
                                    <li className="list-inline-item"><Link className="text-light ic-2x" to="#"><i
                                        className="la la-facebook"/></Link>
                                    </li>
                                    <li className="list-inline-item"><Link className="text-light ic-2x" to="#"><i
                                        className="la la-instagram"/></Link>
                                    </li>
                                    <li className="list-inline-item"><Link className="text-light ic-2x" to="#"><i
                                        className="la la-twitter"/></Link>
                                    </li>
                                    <li className="list-inline-item"><Link className="text-light ic-2x" to="#"><i
                                        className="la la-linkedin"/></Link>
                                    </li>
                                </ul>
                            </Col>
                        </Row>
                    </div>
                </Row>
                <Row className="text-white text-center mt-8">
                    <Col>
                        <hr className="mb-8"/>
                        Copyright {new Date().getFullYear()} nafsi.ai | All Rights Reserved</Col>
                </Row>
            </Container>
        </footer>);
    }
}

export default Footer;
